import { render } from "./AppMessageInput.vue?vue&type=template&id=26728d4e&scoped=true&ts=true"
import script from "./AppMessageInput.vue?vue&type=script&lang=ts"
export * from "./AppMessageInput.vue?vue&type=script&lang=ts"

import "./AppMessageInput.vue?vue&type=style&index=0&id=26728d4e&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26728d4e"]])

export default __exports__